import React from "react";
import paymentSuccessIcon from "../../../assets/images/icons/billing/payment-success.svg";

const formatDateTime = (value) =>
  new Date(value || Date.now()).toLocaleString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

// Shown after either a prepaid top-up (POST /billing/credits) or a postpaid profile setup
// (POST /ad-account/billing) completes. mode="prepaid" shows the real transaction returned by
// addCredits; mode="postpaid" shows the billing preference just saved instead, since no payment
// happens at postpaid setup time - no card is charged.
export default function AdCreditsSuccessModal({
  mode = "prepaid",
  transactionId,
  amount,
  currency,
  createdAt,
  paymentMethod,
  billingCycle,
  onDone,
}) {
  const dateTime = formatDateTime(createdAt);
  const isPostpaid = mode === "postpaid";

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="relative bg-white rounded-2xl p-6 max-w-sm w-full mx-4 text-center">
        <button
          type="button"
          onClick={onDone}
          className="absolute top-4 right-4 w-8 h-8 rounded-full bg-[#095228] text-white flex items-center justify-center"
        >
          ✕
        </button>

        <img src={paymentSuccessIcon} alt="" className="w-24 h-24 mx-auto mb-2" />
        <h2 className="text-lg font-bold mb-1">
          {isPostpaid ? "Postpaid Billing Set Up Successfully !" : "Credits Added Successfully !"}
        </h2>
        <p className="text-sm text-gray-500 mb-5">
          {isPostpaid
            ? "We'll bill you automatically once you cross your threshold."
            : "Your payment has been successfully done."}
        </p>

        <div className="grid grid-cols-2 gap-3 text-left mb-5">
          {isPostpaid ? (
            <>
              <div className={`border border-gray-200 rounded-lg p-3 ${billingCycle === "monthly" ? "col-span-2" : ""}`}>
                <p className="text-xs text-gray-500">Billing Preference</p>
                <p className="text-sm font-semibold">{billingCycle === "monthly" ? "Monthly" : "Threshold"}</p>
              </div>
              {billingCycle !== "monthly" && (
                <div className="border border-gray-200 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Threshold Amount</p>
                  <p className="text-sm font-semibold">{currency || "$"} {Number(amount || 0).toFixed(2)}</p>
                </div>
              )}
              <div className="border border-gray-200 rounded-lg p-3 col-span-2">
                <p className="text-xs text-gray-500">Set Up On</p>
                <p className="text-sm font-semibold">{dateTime}</p>
              </div>
            </>
          ) : (
            <>
              <div className="border border-gray-200 rounded-lg p-3 overflow-hidden">
                <p className="text-xs text-gray-500">Transaction ID</p>
                <p className="text-sm font-semibold break-all">{transactionId || "—"}</p>
              </div>
              <div className="border border-gray-200 rounded-lg p-3">
                <p className="text-xs text-gray-500">Amount Paid</p>
                <p className="text-sm font-semibold">{currency || "$"} {Number(amount || 0).toFixed(2)}</p>
              </div>
              <div className="border border-gray-200 rounded-lg p-3">
                <p className="text-xs text-gray-500">Date &amp; Time</p>
                <p className="text-sm font-semibold">{dateTime}</p>
              </div>
              <div className="border border-gray-200 rounded-lg p-3">
                <p className="text-xs text-gray-500">Payment Method</p>
                <p className="text-sm font-semibold">{paymentMethod}</p>
              </div>
            </>
          )}
        </div>

        <button
          type="button"
          onClick={onDone}
          className="w-full bg-[#095228] text-white font-semibold py-2.5 rounded-full text-sm hover:opacity-90 transition"
        >
          Done
        </button>
      </div>
    </div>
  );
}
